import { gql } from '@apollo/client';

export const SEND_LEGAL_PERSON_SNAIL_MAIL_VERIFICATION = gql`
    mutation SendLegalPersonSnailMailVerification($externalId: String!) {
        sendLegalPersonSnailMailVerification(externalId: $externalId)
    }
`;

export const SAVE_VERIFICATION_MEMO = gql`
    mutation SaveVerificationMemo($verificationPublicId: String!, $verificationMemo: String!) {
        saveVerificationMemo(verificationPublicId: $verificationPublicId, verificationMemo: $verificationMemo)
    }
`;